// extracted by mini-css-extract-plugin
export default {"root":"completeProfilePopup_root__LjCGb","main_content":"completeProfilePopup_main_content__V075C","cancel":"completeProfilePopup_cancel__PAiZI"};